import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { PDFDownloadLink } from "@react-pdf/renderer";
import LoonSlipPdf from "./LoonSlipPdf";

export class TaxCalculationReport extends Component {
  render() {
    const { loonslipData } = this.props.formData.taxTableResponse;

    let toelagen = [];
    for (const [key, value] of Object.entries(loonslipData)) {
      if (key.startsWith("toelage") && key !== "toelagenSom") {
        if (value.label !== "blanco") {
          toelagen.push({ ...value });
        }
      }
    }

    const toelagenLables = toelagen.map((x) => {
      return <li className="data-p">{x.label}</li>;
    });

    const toelagenValues = toelagen.map((x) => {
      return <li className="data-p">{x.bedrag}</li>;
    });

    let inhoudingen = [];
    for (const [key, value] of Object.entries(loonslipData)) {
      if (key.startsWith("inhouding") && key !== "inhoudingenSom") {
        if (value.label !== "blanco") {
          inhoudingen.push({ ...value });
        }
      }
    }

    const inhoudingenLables = inhoudingen.map((x) => {
      return <li className="data-p">{x.label}</li>;
    });

    const inhoudingenValues = inhoudingen.map((x) => {
      return <li className="data-p">{x.bedrag}</li>;
    });

    return (
      <div className="tax-calc-report">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/loonslip">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Loonslip</Breadcrumb.Item>
        </Breadcrumb>
        <h3>Loonslip</h3>
        <div className="loonslip-data">
          <div>
            <p className="header">Omchrijving</p>
            <ul className="col-results">
              <li>Bruto Salaris</li>
              {toelagenLables}
              {inhoudingenLables}
              <li>Belasting inhouding bruto salaris</li>
              <li>A.O.V inhouding bruto salaris</li>
              <li className="bold">Totaal</li>
              <li className="net">Netto Salaris</li>
            </ul>
          </div>
          <div>
            <p className="header">Bruto</p>
            <ul className="col-results">
              <li>{loonslipData.brutoSalaris}</li>
              <div className="hidden-all">
                {toelagenLables}
                {inhoudingenLables}
                <li className="hidden"> </li>
                <li className="hidden"> </li>
                <li className="hidden"> </li>
                <li className="hidden"> </li>
              </div>
            </ul>
          </div>
          <div>
            <p className="header">Toelagen</p>
            <ul className="col-results">
              <li className="hidden"> </li>
              {toelagenValues}
              <div className="hidden-all">
                {inhoudingenValues}
                <li className="hidden"> </li>
                <li className="hidden"> </li>
              </div>
              <li>{loonslipData.toelagenSom}</li>
              <li className="hidden"> </li>
            </ul>
          </div>
          <div>
            <p className="header">Inhoudingen</p>
            <ul className="col-results">
              <li className="hidden"></li>
              <div className="hidden-all">{toelagenValues}</div>
              {inhoudingenValues}
              <li>{loonslipData.afTeDragenLoonbelasting}</li>
              <li>{loonslipData.aovBedrag}</li>
              <li>{loonslipData.inhoudingenSom}</li>
              <li className="hidden"> </li>
            </ul>
          </div>
          <div>
            <p className="header">Netto</p>
            <ul className="col-results">
              <li className="hidden"></li>
              <div className="hidden-all">
                {toelagenLables}
                {inhoudingenLables}
                <li className="hidden"> </li>
                <li className="hidden"> </li>
                <li className="hidden"> </li>
              </div>
              <li className="net">{loonslipData.nettoInkomen}</li>
            </ul>
          </div>
        </div>
        <div className="mobile-view">
          <div className="labels">
            <ul className="col-results">
              <li>Bruto Salaris</li>
              {toelagenLables}
              <li className="semi-bold">Totaal toelagen</li>
              {inhoudingenLables}
              <li>Belasting inhouding bruto salaris</li>
              <li>A.O.V inhouding bruto salaris</li>
              <li className="semi-bold">Totaal inhoudingen</li>
              <li className="bold">Netto Salaris</li>
            </ul>
          </div>
          <div className="values">
            <ul className="col-results">
              <li>{loonslipData.brutoSalaris}</li>
              <span className="toelagen-values">
                {toelagenValues}
                <li className="som">{loonslipData.toelagenSom}</li>
              </span>
              <span className="inhoudingen-values">
                {inhoudingenValues}
                <li>{loonslipData.afTeDragenLoonbelasting}</li>
                <li>{loonslipData.aovBedrag}</li>
                <li className="som">{loonslipData.inhoudingenSom}</li>
              </span>
              <li className="net">{loonslipData.nettoInkomen}</li>
            </ul>
          </div>
        </div>
        <div className="loonslip-footer">
          <p>*belastbaar</p>
          <button>
            <PDFDownloadLink
              document={
                <LoonSlipPdf
                  inhoudingen={inhoudingen}
                  toelagen={toelagen}
                  loonslipData={loonslipData}
                />
              }
              fileName="Loonslip"
            >
              Genereer PDF
            </PDFDownloadLink>
          </button>
          <p>
            www.tax.sr powered by{" "}
            <a href="https://namidi.com/" target="_blank">
              Namidi.com
            </a>{" "}
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
});

export default connect(mapStateToProps, {})(TaxCalculationReport);
